import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineChart4"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 4V20H2V4H3.5ZM9.66602 8V20H8.16602V8H9.66602ZM15.832 12V20H14.332V12H15.832ZM21.998 16V20H20.498V16H21.998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart4;
